module.exports = __webpack_public_path__ + "static/media/report-cuantificando.3ac83424.jpg";